/* eslint-disable no-new */
export class Notification {
    constructor({ innerHtml, time = 8000 }) {
        this.innerHtml = innerHtml;
        this.time = time;
        this.notification = null;
        this.wrapper = document.querySelector('.notifications-wrapper');
    }

    mount() {
        this.notification = document.createElement('div');
        this.notification.innerHTML = this.innerHtml;
        this.notification.classList = 'notification small';
        this.wrapper.appendChild(this.notification);
        setTimeout(() => this.notification.classList.add('mounted'), 400);
        setTimeout(() => this.unmount(this.notification), this.time);
    }

    unmount() {
        this.notification.classList.remove('mounted');
        setTimeout(() => {
            this.notification.remove();
        }, 1200);
    }
}
